import React, { useEffect, useState } from "react";
import TableHeader from "../../Components/TableHeader";
import Heading from "../../tailwindUI/Heading";
import Pagination from "../../tailwindUI/Pagination";
import Table from "../../tailwindUI/Table";
import classes from "../../module.css/ViewStockDetails.module.css";
import Navbar from "../../tailwindUI/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import DataNotFound from "../../Components/DataNotFound";
import ExcelDownload from "../../Components/ExcelDownload/ExcelDownload";
import Tab from "../../tailwindUI/Tab";
import {
    GridComponent,
    ColumnsDirective,
    ColumnDirective,
    Page,
    Inject,
    Resize,
    Group,
    Sort,
    ColumnMenu,
    Filter,
    Toolbar,
    ExcelExport,
    PdfExport,
  } from "@syncfusion/ej2-react-grids";
  import { registerLicense } from "@syncfusion/ej2-base";

  const groupOptions = { showGroupedColumn: true };
  const filterSettings = { type: "CheckBox" };
  const toolbarOptions = ["ExcelExport", "PdfExport", "CsvExport", "Search"];
  let gridInstance;
  let flag = true;
  function dataBound() {
    if (flag) {
      gridInstance.toolbarModule.toolbar.hideItem(2, true);
      flag = false;
    }
  }

  function toolbarClick(args) {
    switch (args.item.text) {
      case "PDF Export":
        gridInstance.pdfExport();
        break;
      case "Excel Export":
        gridInstance.excelExport();
        break;
      case "CSV Export":
        gridInstance.csvExport();
        break;
    }
  }

const AdminProlongedAllocationReport = () => {
  const getUsersData = JSON.parse(localStorage.getItem("userdata"));
  const getUsersToken = localStorage.getItem("UserToken");
  const edpFilter = getUsersData?.filter((edp) => edp.UserRole === "EDP");
  const edpToken = edpFilter[0].UserToken;
    // console.log(getUsersToken,"jdlkud");
    
  const location = useLocation();
  const pathname = window.location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const term = queryParams.get("term");

  const valuesofterm = () => {
    return term || "";
  };

  let navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [pageResults, setPageResults] = useState(0);
  const [searchTerm, setSearchTerm] = useState(valuesofterm());

  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [sort, setSort] = useState("ASC");
  const [orderSort, setOrderSort] = useState("ASC");
  const [modelSort, setModelSort] = useState("ASC");
  const [variantSort, setVariantSort] = useState("ASC");
  const [feulSort, setFeulSort] = useState("ASC");
  const [colorSort, setColorSort] = useState("ASC");
  const [carStatus, setCarStatus] = useState("ASC");
  const [allExcelData, setAllExcelData] = useState([]);
  const page = parseInt(queryParams.get("page") ? queryParams.get("page") : 1);

  const [tabNum, setTabNum] = useState(0);
  const [maxpages, setMaxpages] = useState(1);
  const [tabname, setTabname] = useState("Allocated");

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/syros", { replace: true });
  };

  useEffect(() => {
    fetchStockDetails();
  }, [searchTerm, page, tabname]);


const fetchStockDetails = async () => {
  try {
    setLoading(true);

    const apiEndpoint = "/api/v1/stockone/am/GM_Prolongend_allocation";  // Single API endpoint

    const response = await fetch(`${global.apiBaseUrl}${apiEndpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: global.authToken,
      },
      body: JSON.stringify({ UserToken: getUsersToken }),
    });

    const data = await response.json();
    setLoading(false);

    if (data.status_code === 200 && data.status === "Success") {
      if (data.message === "data found successfully") {
        setTableData(data.data || []);
        setCount(data.datacount || 0);
        setPageResults(data.data?.length || 0);
        setAllExcelData(data.alldata || []);
        console.log(tableData, "ALL THE DATA");
      } else {
        setTableData([]);
        setCount(0);
        setPageResults(0);
      }
    } else if (data.message.includes("Invalid User Token")) {
      LogOut();
    }
  } catch (error) {
    setLoading(false);
    console.error("Error fetching stock details:", error);
  }
};

  





  const BreadCrumb = {
    pagename: "Prolonged Allocation Report",
    pagePath: "/syros-view-stock-detail",
    pagename1: "",
    pagePath1: "",
  };

  const BreadCrumHomeLink = "/syros-dashboard";

  return (
    <>
      <Navbar navbarType={"admin navbar"} />
      <div className={classes.maincontainer}>
        <div className="mb-4">
          <Heading
            headingType={"Page Headings"}
            headingText={"Prolonged Allocation Report"}
            BreadCrumb={BreadCrumb}
            BreadCrumHomeLink={BreadCrumHomeLink}
          />
        </div>
        
        <div className={classes.table}>
          {loading ? (
            <img
              src="../assets/loadingGif.gif"
              alt="loading"
              className={classes.loader}
            />
          ) : (
            <>
           


                <div className="control-pane">
                              <div className="control-section">
                                <GridComponent
                                  dataSource={tableData}
                                  height="500"
                                  allowPaging={true}
                                  allowResizing={true}
                                  allowGrouping={true}
                                  allowSorting={true}
                                  allowFiltering={true}
                                  showColumnMenu={true}
                                  groupSettings={groupOptions}
                                  filterSettings={filterSettings}
                                  toolbar={toolbarOptions}
                                  allowExcelExport={true}
                                  allowPdfExport={true}
                                  toolbarClick={toolbarClick.bind(this)}
                                  ref={(grid) => (gridInstance = grid)}
                                  dataBound={dataBound.bind(this)}
                                  pageSettings={{ pageCount: 4, pageSizes: true }}
                                  autoFit={true}
                
                                  // pageSettings={{ pageCount: 4, pageSize: 30 }}
                                >
                                  <ColumnsDirective>
                                    <ColumnDirective
                                      field="booking_id"
                                      headerText="Booking Ref No."
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="receipt_num"
                                      headerText="Reciept No."
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="Fullname"
                                      headerText="Customer Name"
                                      width="140"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="customer_mobile"
                                      headerText="Customer Mobile"
                                      width="140"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="car_model"
                                      headerText="Car"
                                      width="150"
                                      textAlign="center"
                                    />
                                    <ColumnDirective
                                      field="car_variant"
                                      headerText="Car Variant"
                                      width="150"
                                      textAlign="center"
                                    />
                                    <ColumnDirective
                                      field="Location"
                                      headerText="Location"
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="AsmName"
                                      headerText="ASM Name"
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="ExecutiveName"
                                      headerText="Executive Name"
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="status"
                                      headerText="Status"
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="booking_date"
                                      headerText="Booking Date"
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                                    <ColumnDirective
                                      field="CommittedDeliveryDate"
                                      headerText="Committed Date"
                                      width="150"
                                      textAlign="center"
                                    ></ColumnDirective>
                
                                    
                                  </ColumnsDirective>
                                  <Inject
                                    services={[
                                      Resize,
                                      Group,
                                      Sort,
                                      ColumnMenu,
                                      Filter,
                                      Page,
                                      Toolbar,
                                      ExcelExport,
                                      PdfExport,
                                    ]}
                                  />
                                </GridComponent>
                              </div>
                            </div>



            </>
          )}
        </div>
        {maxpages > 1 && (
          <div className={classes.pagination}>
            <Pagination maxPages={maxpages} />
          </div>
        )}
      </div>
    </>
  );
};

export default AdminProlongedAllocationReport;
